module.exports = __webpack_public_path__ + "static/hero-image-4a6969d864ec2632478617b2325be496.svg";